import { api } from "core";

export async function getStripeCardsRes(body?: any) {
    return api.post("payment/stripe-methods", body ? body : null);
}


export async function deleteStripeCardRes(body: any) {
    return api.delete("payment/stripe-methods?methodId=" + body.methodId);
}


export async function updateStripeCardRes(body: any) {
    return api.put("payment/update-card", body);
}


export async function getReceiptsRes(paginator: any = 1) {
    return api.get(
        "all-receipts?paginator=" + (Number(paginator) - 1),
    );
}


export async function subscribePlanRes(body: any) {
    return api.post("payment/subscribe-stripe-plan", body);
}

export async function getCurrentPlanRes() {
    return api.get("subscription-plans/user-current-plan");
}


export async function cancelSubscriptionRes(body: any) {
    return api.post("payment/cancel-stripe-subscription", body);
}


export async function getBalanceUserRes() {
    return api.get("payment/getbalance-user");
}


// ADD CARD
export async function addStripeCardRes(body: any) {
    return api.put("payment/stripe-methods", body);
}

export async function getPlansRes() {
    return api.get("subscription-plans");
}

